export default "<app-nav-admin--menu></app-nav-admin--menu>\r\n"